import Cookies from 'universal-cookie';

/**
 * @function setItem stores data in Storage with expire date
 * @param key stored data key
 * @param value value to store
 * @param expire expire data can be undefined to not set expire data
 */
export const setItem = (key, value, expire) => {
  if (expire) {
    const now = Date.now();
    const expiresIn = now + expire * 1000;
    localStorage.setItem(`${key}_expiresIn`, expiresIn.toString());
  }
  localStorage.setItem(key, value);
};

/**
 * @function getItem checks if data has expire data if true and has passed that time will remove all data otherwise return data
 * @param key sotred data key
 */
export const getItem = (key) => {
  const expiresIn = localStorage.getItem(`${key}_expiresIn`);
  if (expiresIn) {
    const now = Date.now();

    if (Number(expiresIn) > now) {
      // expired
      localStorage.removeItem(key);
      localStorage.removeItem(`${key}_expiresIn`);

      return;
    } else {
      return localStorage.getItem(key);
    }
  } else {
    return localStorage.getItem(key);
  }
};

export const setAuthCookie = (authTokens) => {
  localStorage.setItem('authTokens', JSON.stringify(authTokens));
};

export const removeAuthCookie = () => {
  localStorage.removeItem('authTokens');
};

export const getAuthCookie = () => {
  let authToken = localStorage.getItem('authTokens');
  return JSON.parse(authToken);
};

export const setOTPTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('otptoken', value, { path: '/', maxAge: 1000 * 60 * 3, sameSite: true });
};
export const getOTPTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('otptoken')
}

export const removeOTPTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('otptoken', { path: '/' })
};


export const setForgotTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('forgottoken', value, { path: '/', maxAge: 1000 * 60 * 15, sameSite: true });
};
export const getForgotTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('forgottoken')
}

export const removeForgotTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('forgottoken', { path: '/' })
};

export const setRefreshTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('refreshtoken', value, { path: '/', maxAge: 1000 * 60 * 60 * 24 * 7, sameSite: true }); // 7 days
};
export const getRefreshTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('refreshtoken')
}
export const removeRefreshTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('refreshtoken', { path: '/' })
};

export const setSignupTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('signuptoken', value, { path: '/', maxAge: 1000 * 60 * 60, sameSite: true }); //1 hour
};
export const getSignupTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('signuptoken')
}
export const removeSignupTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('signuptoken', { path: '/' })
};

export const setAccessTokenCookie = (value) => {
  const cookie = new Cookies();
  return cookie.set('accesstoken', value, { path: '/', maxAge: 1000 * 60 * 60, sameSite: true }); //1 hour
};
export const getAccessTokenCookie= () =>{
  const cookies = new Cookies();
  return cookies.get('accesstoken')
}
export const removeAccessTokenCookie = () => {
  const cookies = new Cookies();
  return cookies.remove('accesstoken', { path: '/' })
};

export const setConsentCookie = (value) => {
  const cookies = new Cookies();
  return cookies.set('consent', value.toString(), {
    path: '/',
    maxAge: 1000 * 3600 * 24 * 30 * 2, // 2 months
    sameSite: true,
  });
};

export const getConsentCookie = () => {
  const cookies = new Cookies();
  return cookies.get('consent') === 'true';
};

export const setSettingInStorage = (settings) => {
  localStorage.setItem('settings', JSON.stringify(settings));
};

export const getSettingsInStorage = () => {
  return JSON.parse(localStorage.getItem('settings'));
};

export const removeSettingsInStorage = () => {
  localStorage.removeItem('settings');
};

export const setDivisionInStorage = (division) => {
  localStorage.setItem('division', JSON.stringify(division));
};

export const getDivisionInStorage = () => {
  return JSON.parse(localStorage.getItem('division'));
};

export const removeDivisionInStorage = () => {
  localStorage.removeItem('division');
};

export const setDivFilterInStorage = (divFilter) => {
  localStorage.setItem('divFilter', JSON.stringify(divFilter));
};

export const getDivFilterInStorage = () => {
  return JSON.parse(localStorage.getItem('divFilter'));
};

export const removeDivFilterInStorage = () => {
  localStorage.removeItem('divFilter');
};

export const setUserInStorage = (userInfo) => {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
};
export const getUserInStorage = () => {
  return JSON.parse(localStorage.getItem('userInfo'));
};
export const removeUserInStorage = () => {
  localStorage.removeItem('userInfo');
};
export const setNavigationInStorage = (navigations) => {
  localStorage.setItem('navigations', JSON.stringify(navigations));
};
export const getNavigationInStorage = () => {
  return JSON.parse(localStorage.getItem('navigations')||"[]");
};
export const removeNavigationInStorage = () => {
  localStorage.removeItem('navigations');
};


export const setWorkDaysInStorage = (workdays) => {
  localStorage.setItem('workdays', JSON.stringify(workdays));
};
export const getWorkDaysInStorage = () => {
  return JSON.parse(localStorage.getItem('workdays')||"{}");
};
export const removeWorkDaysInStorage = () => {
  localStorage.removeItem('workdays');
};


export const setWorkHoursInStorage = (workdays) => {
  localStorage.setItem('workhours', JSON.stringify(workdays));
};
export const getWorkHoursInStorage = () => {
  return JSON.parse(localStorage.getItem('workhours')||"{}");
};
export const removeWorkHoursInStorage = () => {
  localStorage.removeItem('workhours');
};